import { PipeTransform, Pipe } from '@angular/core';
import { MultiLanguageService } from 'src/app/core/services/multi-language.service';

@Pipe({ name: 'ml' })
export class MultiLanguagePipe implements PipeTransform {
	constructor(
		public ml: MultiLanguageService
	) {

	}

	transform(label,trigger, fromProcessAlias = null) {
		let returnLabel = this.ml.translateLabel(label);
		
		// Handle JSON multi-language data that comes directly from backend
		if (typeof label === 'string' && label.startsWith('{') && label.includes('"es"') && label.includes('"en"')) {
			try {
				const parsedLabel = JSON.parse(label);
				const currentLanguage = this.ml.currentLanguage || 'es';
				returnLabel = parsedLabel[currentLanguage] || parsedLabel['es'] || label;
			} catch (e) {
				// If parsing fails, fall back to original translateLabel method
				returnLabel = this.ml.translateLabel(label);
			}
		}
		
		//console.log("label")
		//console.log(label)
    if (fromProcessAlias) {
      returnLabel = returnLabel + ` ( ${fromProcessAlias} ) `
    }
		//console.log("returnLabel")
		//console.log(returnLabel)
		return returnLabel;
	}
}
